import { render, staticRenderFns } from "./RemInboxList.vue?vue&type=template&id=51a4394f&"
import script from "./RemInboxList.vue?vue&type=script&lang=js&"
export * from "./RemInboxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports